export interface AgencyAgreementPayload {
  property_groups?: Array<{id: string, name: string}>;
}
